module.exports = __webpack_public_path__ + "img/IMG_0708.f112501b.jpeg";